import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { PickersDay } from '@mui/x-date-pickers/PickersDay';
import cn from 'classnames';
import { Tooltip } from '../Tooltip';
import styles from './DatePicker.module.scss';
import { GetDateCalendarTID } from './DatePicker.utils';
export function DayCell(props) {
    var _ref, _ref1;
    const { day, selected, disabled, today, outsideCurrentMonth, getDayMeta, testIdRoot } = props, rest = _object_without_properties(props, [
        "day",
        "selected",
        "disabled",
        "today",
        "outsideCurrentMonth",
        "getDayMeta",
        "testIdRoot"
    ]);
    const { DateCalendarTestIds } = useMemo(()=>GetDateCalendarTID(testIdRoot), [
        testIdRoot
    ]);
    // outsideCurrentMonth filler cells have hidden text but visible ring/tooltip — suppress getDayMeta.
    const meta = outsideCurrentMonth === true ? null : (_ref = getDayMeta === null || getDayMeta === void 0 ? void 0 : getDayMeta(day)) !== null && _ref !== void 0 ? _ref : null;
    const showEvent = (meta === null || meta === void 0 ? void 0 : meta.event) === true && !selected;
    const eventVariant = (_ref1 = meta === null || meta === void 0 ? void 0 : meta.eventVariant) !== null && _ref1 !== void 0 ? _ref1 : 'fill';
    const showEventDot = showEvent && eventVariant === 'dot';
    const showToday = today === true && !selected;
    const year = day.getFullYear();
    const month = day.getMonth() + 1;
    const date = day.getDate();
    const dayBaseId = testIdRoot ? DateCalendarTestIds.Day(testIdRoot, year, month, date) : undefined;
    const dayTooltipId = testIdRoot ? DateCalendarTestIds.DayTooltip(testIdRoot, year, month, date) : undefined;
    const cell = /*#__PURE__*/ _jsx("span", {
        className: styles.dayWrapper,
        children: /*#__PURE__*/ _jsx(PickersDay, _object_spread_props(_object_spread({}, rest), {
            day: day,
            selected: selected,
            disabled: disabled,
            today: today,
            outsideCurrentMonth: outsideCurrentMonth,
            "data-testid": dayBaseId,
            "data-today": showToday ? 'true' : undefined,
            "data-event": showEvent ? 'true' : undefined,
            "data-event-variant": showEvent ? eventVariant : undefined,
            className: cn(styles.day, {
                [styles.dayHasEvent]: showEvent && eventVariant === 'fill',
                [styles.dayHasEventDot]: showEventDot,
                [styles.dayToday]: showToday
            })
        }))
    });
    if ((meta === null || meta === void 0 ? void 0 : meta.tooltip) != null) {
        return /*#__PURE__*/ _jsx(Tooltip, {
            title: meta.tooltip,
            placement: "top",
            testId: dayTooltipId,
            children: cell
        });
    }
    return cell;
}
